import axios from 'axios'

const axiosInstance = axios.create()

const clearInterceptors = (instance) => {
  instance.interceptors.request.handlers = []
  instance.interceptors.response.handlers = []
}

clearInterceptors(axiosInstance)

export const support = async (support) => {
  const { workflowId, ...restOfSupport } = support
  const response = await axiosInstance.post(
    `https://integrations.loopboard.io/api/v1/workflows/${workflowId}/documents`,
    restOfSupport,
    {
      headers: {
        'api-key': process.env.REACT_APP_LOOPBOARD_API_KEY
      }
    }
  )

  return response.data
}
